/* eslint-disable import/no-extraneous-dependencies */
import { ExcelExport } from "@progress/kendo-react-excel-export";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@repo/ui";
import { formatDate } from "date-fns";
import { DownloadCloud } from "lucide-react";
import React, { useEffect } from "react";
import {
  useGetCoinsTemplate,
  useGetMultipleCurrencyTemplate,
  useGetSingCurrencyTemplate,
} from "utils/apis/exchange-service.api";

export default function DownloadTemplate({
  operationDate,
}: {
  operationDate?: Date;
}) {
  let excelExport1: ExcelExport | null;
  let excelExport2: ExcelExport | null;
  let excelExport3: ExcelExport | null;

  const { mutate: getCoinsTemplate, data: coinsTemplateData } =
    useGetCoinsTemplate();
  const { mutate: getSingCurrencyTemplate, data: singleCurrencyTemplateData } =
    useGetSingCurrencyTemplate();
  const { mutate: getMultipleCurrencyTemplate, data: fcTemplateData } =
    useGetMultipleCurrencyTemplate();

  const onDownloadTemplate = (type: string) => {
    if (type === "Single Currency") {
      getSingCurrencyTemplate({
        operationDate: formatDate(
          operationDate || new Date(),
          "yyyy-MM-dd'T'00:00:00.000'Z'",
        ),
      });
    } else if (type === "Foreign Currency") {
      getMultipleCurrencyTemplate({
        operationDate: formatDate(
          operationDate || new Date(),
          "yyyy-MM-dd'T'00:00:00.000'Z'",
        ),
      });
    } else if (type === "AED Coins") {
      getCoinsTemplate({
        operationDate: formatDate(
          operationDate || new Date(),
          "yyyy-MM-dd'T'00:00:00.000'Z'",
        ),
      });
    }
  };

  useEffect(() => {
    if (singleCurrencyTemplateData) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      excelExport1?.save(singleCurrencyTemplateData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleCurrencyTemplateData]);

  useEffect(() => {
    if (coinsTemplateData) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      excelExport2?.save(coinsTemplateData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coinsTemplateData]);

  useEffect(() => {
    if (fcTemplateData) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      excelExport3?.save(fcTemplateData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fcTemplateData]);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" className="gap-2">
            <DownloadCloud /> Download Templates
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[180px]">
          <DropdownMenuItem
            onClick={() => {
              onDownloadTemplate("Single Currency");
            }}
            className="cursor-pointer"
          >
            Single Currency
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              onDownloadTemplate("AED Coins");
            }}
            className="cursor-pointer"
          >
            AED Coins
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              onDownloadTemplate("Foreign Currency");
            }}
            className="cursor-pointer"
          >
            Foreign Currency
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ExcelExport
        ref={(exporter) => {
          excelExport1 = exporter;
        }}
        fileName={`Delivery_Single_Currency_Bags_Assignment_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "serviceDate", title: "Service Date" },
          { field: "routeNo", title: "Route No" },
          { field: "sourceBarcode", title: "Cash Center Barcode" },
          { field: "onwardBarcode", title: "Location Barcode" },
          { field: "sealNo", title: "Seal No" },
          { field: "bagType", title: "Bag Type" },
          { field: "currency", title: "Currency" },
          { field: "value", title: "Value" },
        ]}
      />
      <ExcelExport
        ref={(exporter) => {
          excelExport2 = exporter;
        }}
        fileName={`Delivery_Coins_Assignment_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "serviceDate", title: "Service Date" },
          { field: "routeNo", title: "Route No" },
          { field: "sourceBarcode", title: "Cash Center Barcode" },
          { field: "onwardBarcode", title: "Location Barcode" },
          { field: "bagType", title: "Bag Type" },
          { field: "denomination", title: "Denomination" },
          { field: "count", title: "Count" },
        ]}
      />
      <ExcelExport
        ref={(exporter) => {
          excelExport3 = exporter;
        }}
        fileName={`Delivery_FC_Assignment_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "serviceDate", title: "Service Date" },
          { field: "routeNo", title: "Route No" },
          { field: "sourceBarcode", title: "Cash Center Barcode" },
          { field: "onwardBarcode", title: "Location Barcode" },
          { field: "sealNo", title: "Seal No" },
          { field: "bagType", title: "Bag Type" },
        ]}
      />
    </>
  );
}
